import type { Module } from "../types/user.type";

/** Chat is "connected" when auth/me grants at least one chat-category module. */
export function hasChatModules(
	modules: Module[] | null | undefined,
): boolean {
	if (!modules || modules.length === 0) return false;
	return modules.some((module) => module.module_category === "chat");
}
